export default __webpack_public_path__ + "static/media/updated-ISEO.84560ff2.pdf";